import type { ReactNode } from 'react';
import Box from '@mui/material/Box';

import { useDssSession } from './useDssSession';
import { useDssTheme } from './useDssTheme';

export interface ShellProps {
  readonly children: ReactNode;
}

/**
 * Moldura sem chrome para o modo DSS (iframe dentro do Sigma Cloud): sem
 * Sidebar/Navbar/Footer, sem skin de conta nem favicon — esse chrome é do
 * Sigma_Client. Hospeda o conteúdo da rota, que hoje é a feature Angular embutida.
 */
export function DssShell({ children }: ShellProps): JSX.Element {
  const { loaded, theme } = useDssSession();
  useDssTheme(theme);

  // position:fixed + inset:0 ancora o container aos 4 cantos do iFrame, impedindo
  // que #root cresça além do viewport e gere scrollbars no Sigma Cloud.
  // O scroll interno fica contido no Box filho (overflowY:auto), sem vazar para a página.
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden' }}>
        {/* O conteúdo só monta depois do handshake, espelhando o gate do caminho legado
            (router-outlet *ngIf="isLiberado()", liberado após tokenSetted). Montar antes
            deixa o Angular bootstrapar sem token, tenant e usuário no sessionStorage: o
            ngOnInit das telas que leem getUsuarioStorage() lança, o change detection para
            no ponto da falha e o restante do template nunca atualiza. A página React lê
            token e tenant do sessionStorage como a folha, então depende do mesmo gate.
            O remonte por navegação é decidido por quem fornece o conteúdo, mesma
            técnica de LayoutShell. */}
        {loaded ? (
          children
        ) : (
          // Classes do SCSS global do DSS (dss-style-*.scss), já carregado no documento.
          <div className="dss-loading">
            <div className="loader" />
          </div>
        )}
      </Box>
    </Box>
  );
}
